import { Component, Inject, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

export interface UsersData {
  name: string;
  id: number;
}


@Component({
  selector: 'app-cancel-appointment',
  templateUrl: './cancel-appointment.component.html',
  styleUrls: ['./cancel-appointment.component.css']
})
export class CancelAppointmentComponent {

  action: string;
  local_data: any;

  constructor(
    public dialogRef: MatDialogRef<CancelAppointmentComponent>,
    private snackBar: MatSnackBar,
    // @Optional() is used to prevent error if no data is passed
    @Optional() @Inject(MAT_DIALOG_DATA) public data: UsersData) {
    this.local_data = { ...data };
    this.local_data.cancelNote = "";
    this.action = this.local_data.action;
  }

  snackBarMessage(msg: any, duration: any) {
    this.snackBar.open(msg, '', {
      duration: duration, panelClass: ['blue-snackbar']
    });
  }

  doAction() {
    if (this.local_data.cancelNote) {
      this.dialogRef.close({ event: 'Accept', data: this.local_data });
    } else {
      this.snackBarMessage('¡El motivo de cancelación es obligatorio!', 5000);
    }
  }

  closeDialog() {
    this.dialogRef.close({ event: 'Cancel' });
  }
}
